import React, { useState, useCallback } from "react";
import styles from "./mobile-menu.module.scss";
import MenuItems from "./MenuItems";
import Programs from "./Programs";
import ProgramsListing from "./ProgramsListing";
import { AssociatedProgramInterface } from ".";
import { useSearchDebounce } from "@/helpers/useSearchDebounce";
import { usePathname } from "next/navigation";
interface ProgramsDetails {
  categoryParentTitle:string;
  categoryTitle: string;
  programsList: Array<unknown>;
}
interface MobileMenuOptProps {
  isSponsoredCertificates: boolean;
  isMenuOpen: boolean;
  menuPage: number;
  setMenuPage: (page: number) => void;
  associatedPrograms: AssociatedProgramInterface[];
  setIsMenuOpen?: (isOpen: boolean) => void;
  headerMenuList?: any;
}

const MobileMenuOpt: React.FC<MobileMenuOptProps> = ({
  isSponsoredCertificates,
  isMenuOpen,
  menuPage,
  setMenuPage,
  associatedPrograms,
  setIsMenuOpen,
  headerMenuList
}) => {
  const pathName = usePathname();
  const [searchValue, setSearchValue] = useState<string>("");
  const decouncedSearchValue  = useSearchDebounce(searchValue, 300);
  const [programsDetails, setProgramsDetails] = useState<ProgramsDetails>({
    categoryParentTitle:"",
    categoryTitle: "",
    programsList: [],
  });

  // Memoized handler for menu page changes
  const onClickHandler = useCallback((pageValue: number) => {
    setMenuPage(pageValue);

    setTimeout(() => {
      window?.webengage?.track("Programs Clicked");
    }, 2500);
  }, []);

  const closeMenuHandler =(href)=>{
    if(pathName == href){
      setIsMenuOpen(false);
    }
  }
  return (
    <div
      className={`${styles.mobileMenuWrapper} ${isMenuOpen ? styles.open : ""}`}>
      <div className={styles.parentMainContainer}>
        <div className={styles.mobileMenuContainer}>
          <MenuItems
            onMenuItemClick={onClickHandler}
            showMenuItem={!searchValue && menuPage === 0}
            isSponsoredCertificates={isSponsoredCertificates}
            associatedPrograms={associatedPrograms}
            closeMenuHandler={closeMenuHandler}
          />

          <Programs
            setMenuPage={setMenuPage}
            setProgramsDetails={setProgramsDetails}
            showPrograms={!searchValue && menuPage === 1}
            closeMenuHandler={closeMenuHandler}
            headerMenuList={headerMenuList}
          />

          <ProgramsListing
            setMenuPage={setMenuPage}
            programsDetails={programsDetails}
            showProgramsListing={!searchValue && menuPage === 2}
            closeMenuHandler={closeMenuHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MobileMenuOpt);
